const contentTypes = {
  EXAM: 'EXAM',
  LESSON: 'LESSON',
};

export default contentTypes;
